export default "__VITE_ASSET__BXsqwG7B__"